import * as React from 'react';
import { IgcNavDrawerItemComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Represents a navigation drawer item.
 * @slot content - The content slot for the drawer item.
 * @slot icon - The slot for the icon of the drawer item.
 * @csspart base - The base wrapper of the drawer item.
 * @csspart icon - The icon container.
 * @csspart content - The content container.
 * @class
 */
export const IgrNavDrawerItem = /* @__PURE__ */ createComponent({
  tagName: 'igc-nav-drawer-item',
  displayName: 'IgrNavDrawerItem',
  elementClass: Component,
  react: React,
});

export type IgrNavDrawerItem = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrNavDrawerItemModule = Component;
